if (!customElements.get('custom-variant-picker')) {
  class CustomVariantPicker extends HTMLElement {
    constructor() {
      super();
      this.variantSelects = document.querySelector('variant-selects');
    }

    connectedCallback() {
      this.addEventListener('change', (e) => {
        const optionId = e.target.dataset.optionValueId;
        const matchingInput = this.variantSelects.querySelector(`input[data-option-value-id="${optionId}"]`);

        if (matchingInput) {
          matchingInput.checked = true;

          const event = new Event('change', { bubbles: true });
          matchingInput.dispatchEvent(event);
        }
      });
    }
  }

  customElements.define('custom-variant-picker', CustomVariantPicker);
}
